<template>
    <section class="notentransfer-mitglieder-selection">
        <template v-if="allowSVSwitch">
            <b-input-group :size="size">
                <b-input-group-prepend is-text>Rolle auswählen:</b-input-group-prepend>
                <b-select
                    v-model="sv.selected"
                    :options="sv.options"
                    :disabled="sv.busy"
                    :size="size"
                    @change="updateSV"
                ></b-select>
            </b-input-group>
            <hr />
        </template>
        <FilteredSelect
            v-model="localRecord"
            :busy="records.busy"
            :options="records.options"
            :size="size"
            :error="records.error"
        />
    </section>
</template>

<script>
import { ApiFactory } from "@/api/ApiFactory.js";
import Size from "@/mixins/Size/Size";
import User from "@/mixins/User/User";
import GroupBy from "@/mixins/GroupBy/GroupBy";
import NotenverwaltungCommon from "@/mixins/NotenverwaltungCommon/NotenverwaltungCommon";
import FilteredSelect from "@/components/FilteredSelect/FilteredSelect";

const NotentransferSVApi = ApiFactory.get("notentransferSV");
const NotenverwaltungApi = ApiFactory.get("notenverwaltung");

export default {
    name: "NotentransferMitgliederSelection",
    mixins: [Size, User, GroupBy, NotenverwaltungCommon],
    props: ["value"],
    components: {
        FilteredSelect
    },
    data() {
        return {
            records: {
                busy: false,
                raw: [],
                data: [],
                options: [],
                error: false
            },
            sv: {
                busy: false,
                data: [],
                options: [],
                selected: this.value.sv_id
            },
            localRecord: this.value,
            allowSVSwitch: false
        };
    },
    computed: {
        svId() {
            return this.sv.selected ? this.sv.selected : this.userId;
        },
        totals() {
            if (
                this.localRecord.sv_id &&
                this.localRecord.werk_id &&
                this.localRecord.noten_id &&
                this.localRecord.notentyp
            ) {
                const totals = this.records.raw
                    .filter(
                        item =>
                            item.sv_id == this.localRecord.sv_id &&
                            item.noten_id == this.localRecord.noten_id &&
                            item.notentyp == this.localRecord.notentyp &&
                            item.werk_id == this.localRecord.werk_id
                    )
                    .map(item => {
                        return {
                            issued: item.issued,
                            returned: item.returned,
                            all: item.total
                        };
                    });
                if (totals.length > 0) {
                    return totals[0];
                }
            }
            return { issued: 0, returned: 0, all: 0 };
        }
    },
    created() {
        this.fetchSV();
    },
    watch: {
        svId: {
            handler(val) {
                if (val) {
                    this.fetchRecords();
                }
            },
            immediate: true
        },
        localRecord: {
            handler(val) {
                this.$emit("input", val);
            }
        },
        totals: {
            handler(val) {
                this.$emit("updateTotals", val);
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        async fetchSV() {
            this.sv.busy = true;
            const response = await NotenverwaltungApi.getSV();
            if (response.ok) {
                var data = response.json.collection;
                var options = data.map(item => {
                    return {
                        value: item.id,
                        text: item.vorname + " " + item.name
                    };
                });
                this.sv.data = data;
                this.sv.options = options;
                this.allowSVSwitch = true;
            }
            this.sv.busy = false;
        },
        async fetchRecords() {
            this.records.busy = true;
            this.records.error = false;
            const response = await NotentransferSVApi.getRecordsForSV(
                this.svId
            );
            if (response.ok) {
                var records = response.json.collection;
                if (records) {
                    this.records.raw = records;
                    records = this.__groupBy(records, "werk_id");

                    var options = [];
                    for (const [key, werk_records] of Object.entries(records)) {
                        var optionGroup = {
                            label: werk_records[0].konzert.bezeichnung,
                            options: []
                        };
                        for (const record of werk_records) {
                            optionGroup.options.push({
                                text: this.getNotenDescription(
                                    record.noten_werk,
                                    record.komponist,
                                    record.ausgabe,
                                    record.notentyp_desc
                                ),
                                value: {
                                    werk_id: record.werk_id,
                                    noten_id: record.noten_id,
                                    notentyp: record.notentyp,
                                    sv_id: this.svId
                                }
                            });
                        }
                        options.push(optionGroup);
                    }

                    this.records.data = records;
                    this.records.options = options;
                } else {
                    this.records.options = [
                        {
                            value: "",
                            text: "Momentan gibt es keine ausgegebenen Noten"
                        }
                    ];
                    this.records.error = true;
                }
            }
            this.records.busy = false;
        },
        updateSV(val) {
            this.localRecord = {
                sv_id: val,
                werk_id: null,
                noten_id: null,
                notentyp: null
            };
        }
    }
};
</script>